import { render, staticRenderFns } from "./ParticipantDeptsLine.vue?vue&type=template&id=83b2decc&"
import script from "./ParticipantDeptsLine.vue?vue&type=script&lang=js&"
export * from "./ParticipantDeptsLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports